import type { SurveyConfigQuestion, LibraryQuestion } from './types.ts';

export interface SubCategoryGroup {
  subCategory: string | null;
  questions: SurveyConfigQuestion[];
}

/**
 * Groups a dimension's questions into contiguous runs sharing the same sub-category
 * (e.g. Data Questions -> "Data Governance", "Data Architecture", ...), for the
 * Configure Survey checklist. Questions with no library entry (the standard 61) or no
 * sub_category fall into an unheaded group — pure, DOM-free logic, kept in its own
 * module (not the .tsx component) so it can be unit tested directly, same pattern as
 * src/color.ts.
 */
export function groupBySubCategory(
  dimQuestions: SurveyConfigQuestion[],
  libraryById: Map<string, LibraryQuestion>,
): SubCategoryGroup[] {
  const groups: SubCategoryGroup[] = [];
  let current: SubCategoryGroup | null = null;
  for (const q of dimQuestions) {
    const sub = libraryById.get(q.id)?.subCategory ?? null;
    if (!current || current.subCategory !== sub) {
      current = { subCategory: sub, questions: [] };
      groups.push(current);
    }
    current.questions.push(q);
  }
  return groups;
}
